export default __webpack_public_path__ + "static/media/investors.74bdcf1c.webp";